import { Component, Input, OnInit, Injector, EventEmitter, Output } from '@angular/core';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


@Component({
    selector: 'bt-content-expand',
    imports: [LibModulesWolcModule],
    templateUrl: './bt-content-expand.component.html',
    styleUrl: './bt-content-expand.component.scss'
})
export class BtContentExpandComponent {

  @Input() expanded: boolean = false;
  @Input() height: number = 100;
  @Input() opts: any = { };


  constructor() {

  }

  ngOnInit(): void {


  }

}


